import designSystem from '@styles/designSystem';
import styles from "@styles/components/Components.module.css";
// Main vertical container for pages

interface BaseContainerProps {
    children: React.ReactNode
    maxWidth?: string
    maxHeight?: string
    height?: string
    width?: string
    gap?: string
    backgroundColor?: string
    padding?: string
    paddingLeft?: string
    paddingTop?: string
    paddingRight?: string
    paddingBottom?: string
    alignment?: string
}

interface VerticalContainerProps extends BaseContainerProps {
    // No additional props needed for vertical container
}

interface HorizontalContainerProps extends BaseContainerProps {
    horizontalPadding?: string
    justifyContent?: string
}

export const VerticalMainContainer: React.FC<VerticalContainerProps> = ({ 
    children, 
    maxWidth = '1200px',
    gap = designSystem.gapLg,
    backgroundColor = designSystem.colorBackgroundGray3
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            maxWidth: maxWidth,
            margin: '0 auto',
            padding: designSystem.paddingLgScreen,
            fontFamily: designSystem.fontFamily,
            backgroundColor: backgroundColor
        }}>
            {children}
        </div>
    );
};

export const VerticalContainer: React.FC<VerticalContainerProps> = ({ 
    children, 
    maxWidth = '100%',
    maxHeight = undefined,
    height = undefined,
    width = "100%",
    gap = designSystem.gapMd,
    backgroundColor = 'transparent',
    alignment = 'start',
    padding = designSystem.paddingZero,
    paddingLeft = designSystem.paddingZero,
    paddingTop = designSystem.paddingZero,
    paddingRight = designSystem.paddingZero,
    paddingBottom = designSystem.paddingZero,
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: gap,
            width: width,
            maxWidth: maxWidth,
            maxHeight: maxHeight,
            height: height,
            margin: '0 auto',
            padding: padding,
            paddingLeft: paddingLeft,
            paddingRight: paddingRight,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            fontFamily: designSystem.fontFamily,
            backgroundColor: backgroundColor,
            alignItems: alignment
        }}>
            {children}
        </div>
    );
};

export const HorizontalSpacer: React.FC = () => {
    return (
        <div style={{width: '100%'}}/>
    )
}

export const VerticalSpacer: React.FC = () => {
    return (
        <div style={{height: '100%'}}/>
    )
}

export const HorizontalContainer: React.FC<HorizontalContainerProps> = ({ 
    children, 
    maxHeight = undefined,
    height = undefined,
    horizontalPadding = designSystem.paddingZero,
    backgroundColor = 'transparent',
    alignment = 'center',
    justifyContent = designSystem.justifyContentLeft,
    gap = designSystem.gapMd
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            gap: gap,
            height: height,
            maxHeight: maxHeight,
            width: "100%",
            maxWidth: "100%",
            margin: '0',            
            padding: designSystem.paddingZero,
            paddingLeft: horizontalPadding,
            paddingRight: horizontalPadding,
            fontFamily: designSystem.fontFamily,
            backgroundColor: backgroundColor,
            alignContent: alignment,
            justifyContent: justifyContent
        }}>
            {children}
        </div>
    );
};

interface CardContainerProps {
    children: React.ReactNode
    maxWidth?: string
    width?: string
    padding?: string
    backgroundColor?: string
    borderRadius?: string
    boxShadow?: string
}

export const CardContainer: React.FC<CardContainerProps> = ({ 
    children, 
    maxWidth = '100%',
    width = '100%',
    padding = designSystem.paddingSm,
    backgroundColor = designSystem.colorBackgroundWhite,
    borderRadius = designSystem.cornerRadiusComponent,
    boxShadow = designSystem.shadowCard
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: width,
            maxWidth: maxWidth,
            padding: padding,
            backgroundColor: backgroundColor,
            borderRadius: borderRadius,
            boxShadow: boxShadow,
            fontFamily: designSystem.fontFamily
        }}>
            {children}
        </div>
    )
}